import { render, staticRenderFns } from "./MewtwoFightWinNext.vue?vue&type=template&id=44a3dd9b&scoped=true"
import script from "./MewtwoFightWinNext.vue?vue&type=script&lang=js"
export * from "./MewtwoFightWinNext.vue?vue&type=script&lang=js"
import style0 from "./MewtwoFightWinNext.vue?vue&type=style&index=0&id=44a3dd9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3dd9b",
  null
  
)

export default component.exports